import React, { useState, useEffect } from "react";
import { Layout as AntLayout } from "antd";
import Sidebar from "./Sidebar";
import TopHeader from "./TopHeader";
import Footer from "./Footer";

const { Content } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleMenuClick = () => {
    setDrawerVisible(!drawerVisible);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
  };

  return (
    <AntLayout style={{ minHeight: "100vh", backgroundColor: "#FAFAFA" }}>
      <Sidebar
        collapsed={isMobile ? !drawerVisible : false}
        isMobile={isMobile}
        onDrawerClose={handleDrawerClose}
      />

      <AntLayout
        style={{
          marginLeft: isMobile ? 0 : 295,
          backgroundColor: "#FAFAFA",
        }}
      >
        <TopHeader isMobile={isMobile} onMenuClick={handleMenuClick} />

        <Content
          style={{
            padding: "30px 24px 0",
            backgroundColor: "#FAFAFA",
            minHeight: "calc(100vh - 200px)",
          }}
        >
          {children}
        </Content>

        <Footer />
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
